/* src/app/forms/usuarios/user-form-config/user-form-config.component.scss */
.post-thumb {
  float: left;
}
.post-thumb img {
  max-width: 100%;
  max-height: 100%;
  width: 40px;
  height: 40px;
  vertical-align: middle;
  border-radius: 50%;
}
.nz-card-actions {
  align-items: flex-end;
}
.sideLeft {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 25%;
}
.nz-card-header {
  margin-bottom: 15px;
}
.nz-card-title {
  padding-top: 10px !important;
}
.sideRight {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto !important;
  width: 100%;
  gap: 8px;
  padding-top: 8px;
  padding-right: 8px;
}
.sideLeftPassWord {
  float: left;
  width: 100%;
  display: flex;
  float: left;
  width: 100%;
  gap: 8px;
  flex-direction: column;
}
.sideRightPassWord {
  float: right;
  width: 100%;
}
.example-form-field {
  width: 100%;
}
.content {
  width: 100%;
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: auto;
  padding-top: 10px;
}
.content-col {
  width: 100%;
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: auto;
}
.hide {
  display: none;
}
.pgbar {
  width: 85%;
}
.nz-form-item {
  width: 100%;
}
.nz-dialog-container {
  overflow: auto !important;
}
.is-invalid {
  border-left: solid 6px red;
}
.material-icons {
  display: inline-flex;
  vertical-align: middle;
}
.password-form {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.password-new-confirmation {
  display: flex;
  gap: 8px;
  flex-direction: row;
  width: 100%;
}
.password-new-confirmation .fields {
  width: 50%;
}
:host {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}
/*# sourceMappingURL=user-form-config.component.css.map */
